import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import "./UserHomeStyle.css";
import amex1 from "../Images/amex-1.png";
import Iconregister from "../../assets/Iconregister.svg";
import { PdfEnglish, PdfJapanese } from "../../constants/pdfConstants";

function UserHomePage(props) {
  const [url, setURL] = useState(window.location.href);
  const history = useHistory();
  const { t, i18n } = useTranslation("common");
  const [toggle, setToggle] = useState(false);
  const [align, setAlign] = useState(false);
  localStorage.setItem("lang", i18n.language);
  const handleChange = (e) => {
    if (e.target.value === "english") {
      i18n.changeLanguage("en");
    } else if (e.target.value === "japanese") {
      i18n.changeLanguage("jap");
    }
  };

  window.addEventListener(
    "resize",
    () => {
      if (window.innerWidth < 800) {
        setAlign(true);
      } else {
        setAlign(false);
      }
    },
    false
  );

  useEffect(() => {
    if (window.innerWidth < 800) {
      setAlign(true);
    } else {
      setAlign(false);
    }
  }, []);

  return (
    <>
      <div className="hero-bg" style={{ backgroundImage: `url(${amex1})` }}>
        <nav
          className={
            "nav nav-large nav-header nav-sticky nav-inverse navsm " +
            (align ? "nav-vertical" : "nav-horizontal")
          }
          style={{ backgroundColor: "#37393c", opacity: "0.7" }}
          data-toggle="nav"
          data-responsive="true"
        >
          <div className="nav-overlay"></div>
          <div className="nav-brand">
            <span className="dls-logo-bluebox-solid-md flex">
              <Link to="/" rel="noopener noreferrer">
                <img
                  src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/logos/dls-logo-bluebox-solid.svg"
                  alt="American Express"
                />
              </Link>
            </span>
            <ul className="nav-menu">
              <li
                className="nav-title"
                aria-current="false"
                aria-label="Primary"
              >
                <Link to="/" rel="noopener noreferrer" className="nav-links">
                  American Express @ Work
                  <img
                    src={Iconregister}
                    alt="register icon"
                    style={{ padding: "5px" }}
                  />
                </Link>
              </li>
            </ul>
          </div>

          <button
            className="nav-burger hidden-md-up nav-burger-sm"
            title="Close menu"
            aria-haspopup="true"
            aria-expanded={toggle}
            onClick={() => setToggle(!toggle)}
          ></button>

          <ul className="nav-menu">
            <li
              className="nav-item nav-right-item"
              aria-current="false"
              aria-label="Primary"
            >
              <Link
                to="/privacy-links"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                {t("header.privacylinks")}
              </Link>
            </li>

            <li
              className="nav-item nav-right-item"
              aria-current="false"
              aria-label="Primary"
            >
              <Link
                to="/products-and-roles"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                {t("header.prodcutsandroles")}
              </Link>
            </li>

            <li
              className="nav-item nav-right-item"
              aria-current="false"
              aria-label="Primary"
            >
              <Link
                to="/contact-us"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                {t("header.contactus")}
              </Link>
            </li>

            <li
              className="nav-item nav-right-item"
              aria-current="false"
              aria-label="Primary"
            >
              {localStorage.getItem("lang") === "en" ? (
                <a
                  href={PdfEnglish}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link"
                >
                  {t("header.onboardingGuide")}
                </a>
              ) : (
                <a
                  href={PdfJapanese}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link"
                >
                  {t("header.needHelp")}
                </a>
              )}
            </li>
            <ul className="list-links-inline-separator">
              <li>
                <button value="english" onClick={handleChange}>
                  English
                </button>
              </li>
              <li>
                <button value="japanese" onClick={handleChange}>
                  日本語
                </button>
              </li>
            </ul>
          </ul>
        </nav>
        <div className="homebox">
          <div className="homecol">
            <div className="titles">
              <div className="heading-6">American Express</div>
              <br />

              <p className="body-3">{t("header.maintext")}</p>
            </div>
          </div>
          <div className="userscol">
            <div className="buttoncont stack-1-r ">
              <div className="innerdiv">
                <button
                  className="buttondiv btn-secondary bthomeDiv"
                  aria-label="Secondary"
                  onClick={() => {
                    history.push("/new-user");
                  }}
                // disabled={
                //   url === "https://atworkenrollment-qa.americanexpress.com/"
                //     ? true
                //     : false
                // }
                >
                  <span className="icon icon-lg dls-icon-account"></span>
                  <p className="usertitles">
                    <b>{t("header.newuser")}</b>
                  </p>
                </button>
              </div>
              <div className="innerdiv">
                <button
                  className="buttondiv btn-secondary bthomeDiv"
                  aria-label="Secondary"
                  onClick={() => {
                    history.push("/modify-user");
                  }}
                // disabled={
                //   url === "https://atworkenrollment-qa.americanexpress.com/"
                //     ? true
                //     : false
                // }
                >
                  <span className="icon icon-lg dls-icon-edit"></span>
                  <p className="usertitles">
                    <b>{t("header.modifyuser")}</b>
                  </p>
                </button>
              </div>
              <div className="innerdiv">
                <button
                  className="buttondiv btn-secondary bthomeDiv"
                  aria-label="Secondary"
                  onClick={() => {
                    history.push("/delete-user");
                  }}
                // disabled={
                //   url === "https://atworkenrollment-qa.americanexpress.com/"
                //     ? true
                //     : false
                // }
                >
                  <span className="icon icon-lg dls-icon-trash"></span>
                  <p className="usertitles">
                    <b>{t("header.deleteuser")}</b>
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserHomePage;
